export default function useCalendar() {
    const icsMSG = (data) => {
        return `BEGIN:VCALENDAR
                VERSION:2.0
                PRODID:-//Microsoft Corporation//Outlook 16.0 MIMEDIR//EN
                BEGIN:VEVENT
                TZID:China/Beijing
                DTSTART:${data.startTime ? formatDateToICal(new Date(data.startTime)) : ''}
                DTEND:${data.endTime ? formatDateToICal(new Date(data.endTime)) : ''}
                SUMMARY:${data.title}
                DESCRIPTION:${data.description || ''}
                LOCATION:${data.location || ''}
                END:VEVENT
                END:VCALENDAR`;
    };
    const downloadIcs = (data) => {
        let ics = icsMSG(data);
        let blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'calendar.ics';
        a.click();
        URL.revokeObjectURL(url);
        a = null;
    };
    return { downloadIcs };
}

function formatDateToICal(date) {
    const tzOffset = date.getTimezoneOffset() * 60000;
    const localISOTime = new Date(date.getTime() - tzOffset).toISOString().slice(0, -1);
    const t = localISOTime.replace(/[-:]/g, '').slice(0, 15);
    console.log(1111, t);
    return t;
}
